module.exports = __webpack_public_path__ + "img/ic_coupon_activity.c2613590.png";